import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue";
const _hoisted_1 = { class: "siteSearch" };
const _hoisted_2 = {
    key: 0,
    class: "siteSearch-inputWrapper"
};
const _hoisted_3 = ["placeholder"];
const _hoisted_4 = {
    key: 1,
    class: "siteSearch-top is--unavailable"
};
const _hoisted_5 = { class: "siteSearch-top" };
const _hoisted_6 = { class: "resCount" };
const _hoisted_7 = { class: "resCount" };
const _hoisted_8 = ["selected"];
const _hoisted_9 = ["value", "selected"];
const _hoisted_10 = ["href"];
const _hoisted_11 = {
    key: 0,
    class: "siteSearch-error"
};
const _hoisted_12 = {
    key: 1,
    class: "siteSearch-noResults"
};
const _hoisted_13 = {
    key: 2,
    class: "siteSearch-results"
};
const _hoisted_14 = {
    key: 0,
    class: "siteSearch-resultsGroup"
};
const _hoisted_15 = { class: "siteSearch-subSectionHeader" };
const _hoisted_16 = { class: "siteSearch-productCategories" };
const _hoisted_17 = { class: "siteSearch-subSectionHeader" };
const _hoisted_18 = { class: "siteSearch-applAreas" };
const _hoisted_19 = ["data-index"];
const _hoisted_20 = {
    key: 1,
    class: "buttonWrapper"
};
import { computed, nextTick, onUnmounted, reactive, ref, watch } from 'vue';
import { theme } from '../../Theme';
import { ThemeButton, ThemeIcon, ThemeButtonGroup } from '../../components';
import { getStandAloneSearchArgsDefaults, indexesCardComponents, MIN_INPUT_LENGTH, getMultiSearchArgsDefaults, } from './SiteSearch';
import { ThemeMediaSize } from '../../defs/types';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SiteSearch',
    props: {
        query: {},
        withoutInput: { type: Boolean },
        autoFocusInput: { type: Boolean },
        leadToSearchPage: { type: Boolean },
        initialIndexUid: {},
        initialMatchingStrategy: {}
    },
    emits: ["indexChange", "queryChange", "searchResult"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const api = theme().meiliSearchApi;
        const indexes = theme().json.meilisearch.indexes;
        const i18n = useI18n();
        const searchAllBtn = ref();
        const activeIndexSelectorEl = ref();
        const searchPageLinkEl = ref();
        const matchingStrategy = ref(props.initialMatchingStrategy || 'all');
        const matchingStrategies = [
            {
                key: 'all',
                label: i18n.t('search.strategies.all.label'),
                description: i18n.t('search.strategies.all.description'),
            },
            {
                key: 'last',
                label: i18n.t('search.strategies.last.label'),
                description: i18n.t('search.strategies.last.descriptioin'),
            },
        ];
        const ownQueryInputEl = ref();
        const ownQuery = ref(props.query || '');
        const activeIndexUid = ref(props.initialIndexUid || null);
        const activeIndex = computed(() => indexes.find(i => i.uid === activeIndexUid.value));
        const results = ref([]);
        const filteredResults = computed(() => results.value.filter(res => activeIndexUid.value ? res.indexUid === activeIndexUid.value : true));
        const searchError = ref(null);
        const hasResults = computed(() => filteredResults.value.some(res => res.result.hits.length));
        const state = reactive({
            searching: false,
            searchInQueue: false,
            mediaSize: theme().mediaSize,
        });
        const query = computed(() => {
            var _a;
            const query = ((_a = (props.withoutInput ? props.query : ownQuery.value)) === null || _a === void 0 ? void 0 : _a.trim()) || '';
            return (query === null || query === void 0 ? void 0 : query.length) >= MIN_INPUT_LENGTH ? query : '';
        });
        const productHits = computed(() => {
            var _a, _b;
            return (((_b = (_a = results.value.find(res => res.indexUid === 'vtec_products')) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.hits) || []);
        });
        const productCategories = computed(() => {
            return Object.values(productHits.value
                .filter(hit => hit.product_categories.length)
                .reduce((acc, hit) => {
                var _a;
                (((_a = hit._formatted) === null || _a === void 0 ? void 0 : _a.product_categories) || hit.product_categories).forEach((cat) => {
                    if (!acc[cat.id]) {
                        acc[cat.id] = cat;
                    }
                });
                return acc;
            }, {})).sort((a, b) => a.label > b.label ? 1 : -1);
        });
        const applicationAreas = computed(() => {
            return Object.values(productHits.value
                .filter(hit => hit.application_areas.primary.length || hit.application_areas.secondary.length)
                .reduce((acc, hit) => {
                var _a;
                const applAreas = (((_a = hit._formatted) === null || _a === void 0 ? void 0 : _a.application_areas) || hit.application_areas);
                applAreas.primary.forEach((area) => {
                    if (!acc[area.id]) {
                        acc[area.id] = Object.assign(Object.assign({}, area), { primary: true });
                    }
                });
                applAreas.secondary.forEach((area) => {
                    if (!acc[area.id]) {
                        acc[area.id] = Object.assign(Object.assign({}, area), { primary: false });
                    }
                });
                return acc;
            }, {})).sort((a, b) => a.label > b.label ? 1 : -1).sort((a, b) => a.primary && b.primary ? 0 : a.primary ? -1 : 0);
        });
        const emit = __emit;
        __expose({
            focus: () => {
                var _a, _b;
                if (ownQueryInputEl.value) {
                    (_a = ownQueryInputEl.value) === null || _a === void 0 ? void 0 : _a.focus();
                }
                else {
                    (_b = searchAllBtn.value) === null || _b === void 0 ? void 0 : _b.focus();
                }
            },
        });
        theme().attachBreakpointListener(onResizeBreakpoint);
        onUnmounted(() => {
            theme().removeBreakpointListener(onResizeBreakpoint);
        });
        watch(() => matchingStrategy.value, (after, before) => {
            if (after !== before) {
                search();
            }
        });
        watch(() => query.value, async (after, before) => {
            if (after !== before) {
                if (after === null || after === void 0 ? void 0 : after.length) {
                    search();
                }
                else {
                    results.value = [];
                }
                emit('queryChange', after || '');
            }
        });
        watch(() => activeIndexUid.value, async (after, before) => {
            emit('indexChange', after || null);
        });
        if (!props.withoutInput && props.autoFocusInput) {
            nextTick(() => {
                var _a;
                (_a = ownQueryInputEl.value) === null || _a === void 0 ? void 0 : _a.focus();
            });
        }
        if (query.value) {
            search();
        }
        function onResizeBreakpoint(event) {
            state.mediaSize = event.detail.size;
        }
        async function search() {
            if (!theme().json.meilisearch.isAvailable) {
                return;
            }
            if (state.searching) {
                state.searchInQueue = true;
                return;
            }
            searchError.value = null;
            state.searching = true;
            try {
                const indexesArgs = getMultiSearchArgsDefaults();
                for (const key of Object.keys(indexesArgs)) {
                    indexesArgs[key].matchingStrategy = matchingStrategy.value;
                }
                const resp = await api.multiSearch({
                    q: query.value,
                    limit: 3,
                }, indexesArgs);
                results.value = Object.entries(resp).map(([indexUid, result]) => {
                    const primeIndexUid = indexUid;
                    return {
                        indexUid: primeIndexUid,
                        indexData: indexes.find(index => index.uid === primeIndexUid),
                        result,
                    };
                });
            }
            catch (err) {
                searchError.value = err;
                console.error(err);
            }
            state.searching = false;
            if (state.searchInQueue) {
                state.searchInQueue = false;
                await search();
            }
            emit('searchResult', results.value);
        }
        async function reloadIndex(indexUid) {
            var _a;
            const indexArgs = activeIndexUid.value
                ? getStandAloneSearchArgsDefaults(indexUid)
                : getMultiSearchArgsDefaults()[indexUid];
            const args = Object.assign(Object.assign({}, indexArgs), { q: query.value });
            const resultsEntry = results.value.find(r => r.indexUid === indexUid);
            if ((_a = resultsEntry === null || resultsEntry === void 0 ? void 0 : resultsEntry.result) === null || _a === void 0 ? void 0 : _a.hits.length) {
                args.limit = Math.max(args.limit || 0, (resultsEntry === null || resultsEntry === void 0 ? void 0 : resultsEntry.result.hits.length) || 0);
            }
            const resp = await api.search(indexUid, args);
            results.value = results.value.map(entry => {
                if (entry.indexUid === indexUid) {
                    return Object.assign(Object.assign({}, entry), { result: resp });
                }
                return entry;
            });
        }
        function canLoadMore(response) {
            return Math.max(response.limit, response.hits.length) < response.estimatedTotalHits;
        }
        async function loadMore(indexUid, prevResponse) {
            try {
                searchError.value = null;
                const indexArgs = getStandAloneSearchArgsDefaults(indexUid);
                const resp = await api.search(indexUid, Object.assign(Object.assign({}, indexArgs), { q: query.value || '', offset: prevResponse.hits.length, matchingStrategy: matchingStrategy.value }));
                results.value = results.value.map(entry => {
                    if (entry.indexUid === indexUid) {
                        return Object.assign(Object.assign({}, entry), { result: Object.assign(Object.assign({}, resp), { hits: [
                                    ...prevResponse.hits,
                                    ...resp.hits,
                                ] }) });
                    }
                    return entry;
                });
            }
            catch (err) {
                searchError.value = err;
                console.error(err);
            }
        }
        function onActiveIndexSelectValueChange(event) {
            const select = event.target;
            activeIndexUid.value = select.value || null;
        }
        function emptyOwnQuery() {
            var _a;
            ownQuery.value = '';
            (_a = ownQueryInputEl.value) === null || _a === void 0 ? void 0 : _a.focus();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!_ctx.withoutInput)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _withDirectives(_createElementVNode("input", {
                            type: "search",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((ownQuery).value = $event)),
                            ref_key: "ownQueryInputEl",
                            ref: ownQueryInputEl,
                            placeholder: _ctx.$t('search.placeholder'),
                            spellcheck: "false",
                            autocomplete: "off",
                            onKeydown: _cache[1] || (_cache[1] = _withKeys(($event) => { var _a; return ((_a = searchPageLinkEl.value) === null || _a === void 0 ? void 0 : _a.click()); }, ["enter"]))
                        }, null, 40, _hoisted_3), [
                            [_vModelText, ownQuery.value]
                        ]),
                        _createVNode(_unref(ThemeIcon), { name: "magnifying-glass" })
                    ]))
                    : _createCommentVNode("", true),
                (!_unref(theme)().json.meilisearch.isAvailable)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('search.unavailable')), 1)
                    ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("div", _hoisted_5, [
                            (state.mediaSize > _unref(ThemeMediaSize).Medium)
                                ? (_openBlock(), _createBlock(_unref(ThemeButtonGroup), { key: 0 }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(ThemeButton), {
                                            title: _ctx.$t('search.all'),
                                            class: _normalizeClass({ 'is--active': !activeIndexUid.value }),
                                            fill: !activeIndex.value ? 'solid' : 'outline',
                                            size: "small",
                                            onClick: _cache[2] || (_cache[2] = ($event) => (activeIndexUid.value = null)),
                                            ref_key: "searchAllBtn",
                                            ref: searchAllBtn
                                        }, {
                                            title: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('search.all')) + " ", 1),
                                                _createElementVNode("span", _hoisted_6, _toDisplayString(results.value.reduce((acc, res) => acc + res.result.estimatedTotalHits, 0) || '0'), 1)
                                            ]),
                                            _: 1
                                        }, 8, ["title", "class", "fill"]),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(indexes), (index) => {
                                            return (_openBlock(), _createBlock(_unref(ThemeButton), {
                                                key: index.uid,
                                                title: index.label,
                                                class: _normalizeClass({ 'is--active': activeIndexUid.value === index.uid }),
                                                fill: activeIndexUid.value === index.uid ? 'solid' : 'outline',
                                                size: "small",
                                                onClick: ($event) => (activeIndexUid.value = index.uid)
                                            }, {
                                                title: _withCtx(() => {
                                                    var _a;
                                                    return [
                                                        _createTextVNode(_toDisplayString(index.label) + " ", 1),
                                                        _createElementVNode("span", _hoisted_7, _toDisplayString(((_a = results.value.find(res => res.indexUid === index.uid)) === null || _a === void 0 ? void 0 : _a.result.estimatedTotalHits) || '0'), 1)
                                                    ];
                                                }),
                                                _: 2
                                            }, 1032, ["title", "class", "fill", "onClick"]));
                                        }), 128))
                                    ]),
                                    _: 1
                                }))
                                : (_openBlock(), _createElementBlock("select", {
                                    key: 1,
                                    onChange: onActiveIndexSelectValueChange,
                                    ref_key: "activeIndexSelectorEl",
                                    ref: activeIndexSelectorEl
                                }, [
                                    _createElementVNode("option", {
                                        value: "",
                                        selected: !activeIndexUid.value
                                    }, _toDisplayString(_ctx.$t('search.all') + ` (${results.value.reduce((acc, res) => acc + res.result.estimatedTotalHits, 0) || '0'})`), 9, _hoisted_8),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(indexes), (index) => {
                                        var _a;
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: index.uid,
                                            value: index.uid,
                                            selected: activeIndexUid.value === index.uid
                                        }, _toDisplayString(index.label + ` (${((_a = results.value.find(res => res.indexUid === index.uid)) === null || _a === void 0 ? void 0 : _a.result.estimatedTotalHits) || '0'})`), 9, _hoisted_9));
                                    }), 128))
                                ], 544)),
                            _createVNode(_unref(ThemeButtonGroup), null, {
                                default: _withCtx(() => [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(matchingStrategies, (strategy) => {
                                        var _a;
                                        return _createVNode(_unref(ThemeButton), {
                                            key: strategy.key,
                                            title: strategy.label,
                                            fill: matchingStrategy.value === strategy.key ? 'solid' : 'outline',
                                            size: "small",
                                            color: matchingStrategy.value === strategy.key ? 'dark' : 'gray',
                                            disabled: (((_a = query.value) === null || _a === void 0 ? void 0 : _a.indexOf(' ')) || 0) < 0,
                                            "wca-title": strategy.description,
                                            onClick: ($event) => (matchingStrategy.value = strategy.key)
                                        }, null, 8, ["title", "fill", "color", "disabled", "wca-title", "onClick"]);
                                    }), 64))
                                ]),
                                _: 1
                            }),
                            (_ctx.leadToSearchPage)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 2,
                                    class: "siteSearch-pageLink",
                                    href: _ctx.$t('search.search_url', { search_input: query.value }),
                                    ref_key: "searchPageLinkEl",
                                    ref: searchPageLinkEl
                                }, _toDisplayString(_ctx.$t('search.view_all_results')), 9, _hoisted_10))
                                : _createCommentVNode("", true)
                        ]),
                        (searchError.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.$t('search.unknown_error')), 1)
                            ]))
                            : (!hasResults.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('search.no_results')), 1)
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredResults.value, (entry) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                            key: entry.indexUid
                                        }, [
                                            (entry.result.hits.length)
                                                ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
                                                    _createElementVNode("header", null, [
                                                        _createElementVNode("h2", null, _toDisplayString(entry.indexData.label), 1)
                                                    ]),
                                                    (entry.indexUid === 'vtec_products')
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            (productCategories.value.length)
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t('search.product_categories')), 1),
                                                                    _createElementVNode("ul", _hoisted_16, [
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productCategories.value, (cat) => {
                                                                            return (_openBlock(), _createElementBlock("li", {
                                                                                key: cat.id
                                                                            }, [
                                                                                _createVNode(_unref(ThemeButton), {
                                                                                    type: "link",
                                                                                    href: cat.url,
                                                                                    title: cat.label,
                                                                                    variation: "chip",
                                                                                    size: "small",
                                                                                    fill: "outline",
                                                                                    color: "primary"
                                                                                }, null, 8, ["href", "title"])
                                                                            ]));
                                                                        }), 128))
                                                                    ])
                                                                ], 64))
                                                                : _createCommentVNode("", true),
                                                            (applicationAreas.value.length)
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                    _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.$t('search.application_areas')), 1),
                                                                    _createElementVNode("ul", _hoisted_18, [
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(applicationAreas.value, (area) => {
                                                                            return (_openBlock(), _createElementBlock("li", {
                                                                                key: area.id
                                                                            }, [
                                                                                _createVNode(_unref(ThemeButton), {
                                                                                    type: "link",
                                                                                    href: area.url,
                                                                                    title: area.label,
                                                                                    variation: "chip",
                                                                                    size: "small",
                                                                                    fill: "outline",
                                                                                    color: area.primary ? 'dark' : 'primary'
                                                                                }, null, 8, ["href", "title", "color"])
                                                                            ]));
                                                                        }), 128))
                                                                    ])
                                                                ], 64))
                                                                : _createCommentVNode("", true)
                                                        ], 64))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("ul", {
                                                        class: "siteSearch-hits",
                                                        "data-index": entry.indexUid
                                                    }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.result.hits, (hit) => {
                                                            return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(indexesCardComponents)[entry.indexUid]), {
                                                                class: "siteSearch-hit",
                                                                key: hit.id,
                                                                document: hit
                                                            }, null, 8, ["document"]));
                                                        }), 128))
                                                    ], 8, _hoisted_19),
                                                    (canLoadMore(entry.result))
                                                        ? (_openBlock(), _createElementBlock("footer", _hoisted_20, [
                                                            _createVNode(_unref(ThemeButton), {
                                                                title: _ctx.$t('search.load_more'),
                                                                variation: "chip",
                                                                size: "small",
                                                                fill: "outline",
                                                                color: "dark",
                                                                icon: "loading",
                                                                state: state.searching ? 'loading' : '',
                                                                onClick: ($event) => (loadMore(entry.indexUid, entry.result))
                                                            }, null, 8, ["title", "state", "onClick"])
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ], 64));
                                    }), 128))
                                ]))
                    ], 64))
            ]));
        };
    }
});
